import React from 'react';
import { WHATSAPP_URL } from './WhatsAppIcon';
interface ErrorBoundaryProps {
  children: React.ReactNode;
  onReset?: () => void;
}
interface ErrorBoundaryState {
  error: Error | null;
}

/** Si algo falla dentro de una ventana, muestra un aviso en vez de dejar la pantalla trabada. */
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: null
  };
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      error
    };
  }
  componentDidCatch(error: Error) {
    console.error('VCARS — error en la ventana', error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return <div className="py-10 text-center" data-id="element-229" data-mp="gsj1py8vq27s">
        <p className="font-display text-xl font-semibold text-white" data-id="element-230" data-mp="grhobn4e53mw">No pudimos abrir esta sección</p>
        <p className="mt-2 text-sm text-muted" data-id="element-231" data-mp="1eb19f50mbko4">Probá de nuevo o escribinos por WhatsApp.</p>
        <p className="mt-2 break-words text-xs text-muted/70" data-id="element-232" data-mp="19g54536df0t2">{this.state.error.message}</p>
        <div className="mt-6 flex justify-center gap-3" data-id="element-233" data-mp="3n62u5z9zxgg4">
          <button type="button" onClick={() => {
          this.setState({
            error: null
          });
          this.props.onReset?.();
        }} className="h-11 rounded-full bg-neon px-6 text-sm font-semibold text-ink" data-id="element-234" data-mp="3s4njh3npmfps">
            Volver
          </button>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex h-11 items-center rounded-full border border-neon px-6 text-sm font-semibold text-neon" data-id="element-235" data-mp="34dqj8o5a16ud">
            WhatsApp
          </a>
        </div>
      </div>;
  }
}